export default __webpack_public_path__ + "static/media/faction-sa.843f3b77.png";